import GiftCampaignForm from './components/gift-campaigns/GiftCampaignForm.vue';

export default function registerAdminVueComponents(app) {
    app.component('gift-campaign-form', GiftCampaignForm);
}
